import { useLazyQuery } from "@apollo/client";
import { GET_SECTION_CONDITION_FACILITY_COUNT } from "../../queries/siteVisitQrys/sectionConditionsQrys";

const useSectionConditionFacilityCount = () => {
  const [
    fetchFacilityCount,
    { data: facilityCountData, loading: facilityCountLoading, error: facilityCountError },
  ] = useLazyQuery(GET_SECTION_CONDITION_FACILITY_COUNT, { fetchPolicy: "network-only" });

  return {
    data: {
      facilityCount: facilityCountData?.getSectionConditionFacilityCount ?? null,
    },
    loading: {
      facilityCount: facilityCountLoading,
    },
    errors: {
      facilityCount: facilityCountError,
    },
    fetchFacilityCount,
  };
};

export default useSectionConditionFacilityCount;
